import { Component, OnInit } from '@angular/core';
import {NgbModal } from '@ng-bootstrap/ng-bootstrap'; //, ModalDismissReasons
import {FormBuilder, Validators} from '@angular/forms'; //FormGroup, FormControl, 
import { Router } from '@angular/router'; //, NavigationExtras

// PROVIDER
import {BasicProvider} from '../providers/basic/basic';
import {UserProvider} from '../providers/user/user';

import { SigninUpComponent } from '../signin-up/signin-up.component';

@Component({
  selector: 'app-forgot-pass',
  templateUrl: './forgot-pass.component.html',
  styleUrls: ['./forgot-pass.component.css']
})


export class ForgotPassComponent implements OnInit {

  fpForm;
  signin_active;
  signin_show;
  
  public isVisible: boolean = false;
  
  constructor(
    private modalService: NgbModal,
    public builder:FormBuilder,
    public bp:BasicProvider, 
    public up:UserProvider,
    public router: Router,
	  //private popup: PopupService,
  ) {
    if (this.bp.model_type=='fgpass') {
      this.bp.validation_error='';
      this.bp.close();
      this.signin_active = 'active';
      this.signin_show = 'show active';
    }

    this.setsFpForm();
  }


  //Show / hide password
  signin_pass_type = false;
  signup_new_pass_type = false;
  signup_confirm_pass_type = false;
  showPassword(type){
    if( type == 'signin_pass_type' ){
      if(this.signin_pass_type)
        this.signin_pass_type = false;
      else
        this.signin_pass_type = true;
    } else if ( type == 'signup_new_pass_type' ) {
      if(this.signup_new_pass_type)
        this.signup_new_pass_type = false;
      else
        this.signup_new_pass_type = true;
    } else if ( type == 'signup_confirm_pass_type' ) {
      if(this.signup_confirm_pass_type)
        this.signup_confirm_pass_type = false;
      else
        this.signup_confirm_pass_type = true;
    }
  }


  public setsFpForm(){
    this.bp.validation_error = '';
    this.fpForm = this.builder.group({
      email: ['', Validators.compose([Validators.required])],
    })
  }


  ngOnInit() {
  }

  loginOpen(content) {
    this.bp.close();
    this.bp.model_type = 'signin';
    this.bp.model = this.modalService.open(SigninUpComponent, { windowClass: 'signUp-modal' });
    return false;
  }
 
  public fpFormSubmit (event) {
    if( event.keyCode == 13 || event.keyCode == undefined ){
      var validation_message = {
        'email': {
          'required': 'Email is required field.',
          'pattern': 'Please enter valid email.'
        }
      };
      let p = window.location.pathname.replace(this.bp.SUBFOLDER_NAME, "")
      
      
      if (this.bp.validation(this.fpForm, validation_message)) {
        this.bp.validation_error = '';
        let submitData = this.fpForm.value;
        submitData.device_type = this.bp.device_type;

        this.bp.hitApi('users/forgot_password', 'POST', submitData)
            .subscribe(
                success => {  
                    if( success.type == true ){
                      this.bp.show_toast('Success',success.message);
                      this.router.navigate(['home']);  
                    }else{
                      this.bp.show_toast('Error',success.message);
                    } 

            }, 
            error => {}
        );
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/forgot-pass/forgot-pass.component.ts